import axios from 'axios';

export default axios.create({
  baseURL: `https://boards-api.greenhouse.io/v1/boards`,
});
